import { IconButton, Tooltip } from "@mui/material"
import { RefreshNavBar } from "event-definitions"
import { navigate } from "lib/routes/navigate"
import { IconButtonAnimate } from "minimals-template/components/animate"
import { debugInfo } from "minimals-template/components/debug-component/temp-debug-window"
import Iconify from "minimals-template/components/Iconify"

import { AuthTemplateHeader, HeaderBarRight } from "slot-definitions"
import { plug } from "lib/@components/slot/plug"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { ApplicationSwitcher } from "lib/@components/application-switcher/application-switcher"
import { useApplicationSwitcherEligible } from "lib/@components/application-switcher/use-application-switcher-eligible"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SIDE_NAV_REDESIGN } from "routes/@layouts/app/navbar/feature-flag-side-nav-redesign.runtime"

plug("Header.Left", <Home />)
HeaderBarRight.plug(<DebugButton priority={-1000} />)
AuthTemplateHeader.plug(<DebugButton priority={-1000} />)

export function AuthenticatedApplicationSwitcher() {
    const eligible = useApplicationSwitcherEligible()
    if (!eligible) return null

    return <ApplicationSwitcher />
}

HeaderBarRight.plug(<AuthenticatedApplicationSwitcher priority={1000} if={notRedesignedNav} />)
AuthTemplateHeader.plug(<AuthenticatedApplicationSwitcher />)

function Home() {
    return (
        <IconButton aria-label="Home" sx={{ color: "primary.contrastText" }} onClick={() => navigate("/")}>
            <Iconify icon="mdi:home" />
        </IconButton>
    )
}

export function DebugButton() {
    const [debug] = useSearchParam("debug", false)
    const showDebug = process.env.REACT_APP_DEBUG || localStorage.getItem("sfg20-DebugWindow") || debug

    RefreshNavBar.useRefresh()
    if (!showDebug) return null
    return (
        <Tooltip title="Debug Information">
            <IconButtonAnimate onClick={debugInfo} color={"secondary"}>
                <Iconify icon="carbon:debug" />
            </IconButtonAnimate>
        </Tooltip>
    )
}

function notRedesignedNav() {
    return !isEnabled(FEATURE_FLAG_SIDE_NAV_REDESIGN)
}
